const CONTENT_TYPES = {
	MARKDOWN  : {name: 'Markdown', code: 'markdown'},
	ASCIIDOC  : {name: 'Asciidoc', code: 'asciidoc'},
	PLAIN_TEXT: {name: 'Plain Text', code: 'plain_text'}
};

export default class ContentTypes {
	static get MARKDOWN() {
		return _.cloneDeep(CONTENT_TYPES.MARKDOWN);
	}

	static get ASCIIDOC() {
		return _.cloneDeep(CONTENT_TYPES.ASCIIDOC);
	}

	static get PLAIN_TEXT() {
		return _.cloneDeep(CONTENT_TYPES.PLAIN_TEXT);
	}

	static getTypeFromString(value) {
		value = value.toLowerCase().replace(' ','_');
		let type = _.find(CONTENT_TYPES, (item) => {
			return item.code === value;
		});

		return type || CONTENT_TYPES.MARKDOWN;
	}

	static get list() {
		return _.map(CONTENT_TYPES, (item) => {
			return _.cloneDeep(item);
		});
	}
};


// WEBPACK FOOTER //
// ./modules/distribution/core/enums/content.types.js